import { useEffect } from 'react';

/* /support-server – immediately redirects to Discord */
export default function SupportServer() {
  useEffect(() => {
    window.location.replace('https://discord.gg/permsystems');
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'var(--font)',
      color: 'var(--gray-dk)',
      fontSize: '1rem',
      gap: '12px',
    }}>
      <span style={{
        width: 18, height: 18,
        border: '2.5px solid var(--blue-mid)',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        display: 'inline-block',
        animation: 'spin 0.7s linear infinite',
      }} />
      Redirecting to Discord…
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}